export default __webpack_public_path__ + "static/media/home-travel-agency-footer-bg.76a60a22.jpg";